import { render, staticRenderFns } from "./NavbarDashboard.vue?vue&type=template&id=ea81bd04"
import script from "./NavbarDashboard.vue?vue&type=script&lang=js"
export * from "./NavbarDashboard.vue?vue&type=script&lang=js"
import style0 from "./NavbarDashboard.vue?vue&type=style&index=0&id=ea81bd04&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports